import AnalyticsJSBuilderPage from './pipelines/analyticsJSBuilder';

export default {
  AnalyticsJSBuilderPage,
};
